// Common

/**
 *  @swagger
 *  components:
 *    enums:
 *      SocialUserType:
 *        type: string
 *        enum:
 *          - FACEBOOK
 *          - GOOGLE
 */
export enum SocialUserType {
  facebook = 'FACEBOOK',
  google = 'GOOGLE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      DocumentStatus:
 *        type: string
 *        enum:
 *          - CONFIRMED
 *          - PENDING
 *          - REJECTED
 */
export enum DocumentStatus {
  confirmed = 'CONFIRMED',
  pending = 'PENDING',
  rejected = 'REJECTED',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      Gender:
 *        type: string
 *        enum:
 *          - FEMALE
 *          - MALE
 */
export enum Gender {
  female = 'FEMALE',
  male = 'MALE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      Tshirt:
 *        type: string
 *        enum:
 *          - L
 *          - M
 *          - S
 *          - XL
 *          - XS
 *          - XXL
 */
export enum Tshirt {
  l = 'L',
  m = 'M',
  s = 'S',
  xl = 'XL',
  xs = 'XS',
  xxl = 'XXL',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      AdminRequestStatus:
 *        type: string
 *        enum:
 *          - CONFIRMED
 *          - FULFILLED
 *          - PROPOSE
 *          - REQUEST
 */
export enum AdminRequestStatus {
  confirmed = 'CONFIRMED',
  fulfilled = 'FULFILLED',
  propose = 'PROPOSE',
  request = 'REQUEST',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      AdminStatus:
 *        type: string
 *        enum:
 *          - CONFIRMED
 *          - SUSPENDED
 *          - UNCONFIRMED
 */
export enum AdminStatus {
  confirmed = 'CONFIRMED',
  suspended = 'SUSPENDED',
  unconfirmed = 'UNCONFIRMED',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      AdminSocialUserType:
 *        $ref = '#/components/enums/SocialUserType'
 */
export enum AdminSocialUserType {
  facebook = 'FACEBOOK',
  google = 'GOOGLE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      AdminAuthType:
 *        type: string
 *        enum:
 *          - FACEBOOK
 *          - GOOGLE
 *          - LOCAL
 */
export enum AdminAuthType {
  facebook = 'FACEBOOK',
  google = 'GOOGLE',
  local = 'LOCAL',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      AdminAccessTokenStatus:
 *        type: string
 *        enum:
 *          - INVALID
 *          - VALID
 */
export enum AdminAccessTokenStatus {
  invalid = 'INVALID',
  valid = 'VALID',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      AdminAccessTokenAuthType:
 *        $ref = '#/components/enums/AdminAuthType'
 */
export enum AdminAccessTokenAuthType {
  facebook = 'FACEBOOK',
  google = 'GOOGLE',
  local = 'LOCAL',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      AdvertisementType:
 *        type: string
 *        enum:
 *          - CREW
 *          - CREWMEMBER
 */
export enum AdvertisementType {
  crew = 'CREW',
  crewmember = 'CREWMEMBER',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      BannerLocationType:
 *        type: string
 *        enum:
 *          - CHAMPIONSHIP
 *          - HOME
 *          - REGATTA
 */
export enum BannerLocationType {
  championship = 'CHAMPIONSHIP',
  championships = 'CHAMPIONSHIPS',
  regatta = 'REGATTA',
  regattas = 'REGATTAS',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      ChampionshipDocumentStatus:
 *        $ref = '#/components/enums/DocumentStatus'
 */
export enum ChampionshipDocumentStatus {
  confirmed = 'CONFIRMED',
  pending = 'PENDING',
  rejected = 'REJECTED',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      CrewmemberGender:
 *        $ref = '#/components/enums/Gender'
 */
export enum CrewmemberGender {
  female = 'FEMALE',
  male = 'MALE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      CrewmemberTshirt:
 *        $ref = '#/components/enums/Tshirt'
 */
export enum CrewmemberTshirt {
  l = 'L',
  m = 'M',
  s = 'S',
  xl = 'XL',
  xs = 'XS',
  xxl = 'XXL',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      CrewmemberLanguage:
 *        type: string
 *        enum:
 *          - en
 */
export enum CrewmemberLanguage {
  en = 'en',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      CrewmemberSocialUserType:
 *        $ref = '#/components/enums/SocialUserType'
 */
export enum CrewmemberSocialUserType {
  facebook = 'FACEBOOK',
  google = 'GOOGLE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      CrewmemberAuthType:
 *        $ref = '#/components/enums/SocialUserType'
 */
export enum CrewmemberAuthType {
  facebook = 'FACEBOOK',
  google = 'GOOGLE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      CrewmemberAccessTokenStatus:
 *        type: string
 *        enum:
 *          - INVALID
 *          - VALID
 */
export enum CrewmemberAccessTokenStatus {
  invalid = 'INVALID',
  valid = 'VALID',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      CrewmemberAccessTokenAuthType:
 *        $ref = '#/components/enums/CrewmemberAuthType'
 */
export enum CrewmemberAccessTokenAuthType {
  facebook = 'FACEBOOK',
  google = 'GOOGLE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      GroupType:
 *        type: string
 *        enum:
 *          - CRUISER
 *          - SPORT
 */
export enum GroupType {
  cruiser = 'CRUISER',
  sport = 'SPORT',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RatingType:
 *        type: string
 *        enum:
 *          - IRC
 *          - LKRTH
 *          - LYS
 *          - MONOTYPE
 *          - ORC
 *          - VJDH
 */
export enum RatingType {
  irc = 'IRC',
  lkrth = 'LKRTH',
  lys = 'LYS',
  monotype = 'MONOTYPE',
  orc = 'ORC',
  vjdh = 'VJDH',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaDocumentStatus:
 *        $ref = '#/components/enums/DocumentStatus'
 */
export enum RegattaDocumentStatus {
  confirmed = 'CONFIRMED',
  pending = 'PENDING',
  rejected = 'REJECTED',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaCoursePointType:
 *        type: string
 *        enum:
 *          - DEFAULT
 *          - GATE
 *          - INDEPENDENT
 *          - INVISIBLE
 */
export enum RegattaCoursePointType {
  default = 'DEFAULT',
  gate = 'GATE',
  independent = 'INDEPENDENT',
  invisible = 'INVISIBLE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaCoursePointSide:
 *        type: string
 *        enum:
 *          - PORT
 *          - STARBOARD
 */
export enum RegattaCoursePointSide {
  port = 'PORT',
  starboard = 'STARBOARD',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaEntryCrewmemberGender:
 *        $ref = '#/components/enums/Gender'
 */
export enum RegattaEntryCrewmemberGender {
  female = 'FEMALE',
  male = 'MALE',
}
/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaEntryCrewmemberTshirt:
 *        $ref = '#/components/enums/Tshirt'
 */
export enum RegattaEntryCrewmemberTshirt {
  l = 'L',
  m = 'M',
  s = 'S',
  xl = 'XL',
  xs = 'XS',
  xxl = 'XXL',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaMessageType:
 *        type: string
 *        enum:
 *          - DEFAULT
 */
export enum RegattaMessageType {
  organizingAuthority = 'ORGANIZING_AUTHORITY',
  protestCommittee = 'PROTEST_COMMITTEE',
  raceCommittee = 'RACE_COMMITTEE',
  technicalCommittee = 'TECHNICAL_COMMITTEE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaStatus:
 *        type: string
 *        enum:
 *          - CANCELED
 *          - ENDED
 *          - NEW
 *          - ONGOING
 *          - UPCOMING
 */
export enum RegattaStatus {
  canceled = 'CANCELED',
  ended = 'ENDED',
  new = 'NEW',
  ongoing = 'ONGOING',
  upcoming = 'UPCOMING',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaLogAction:
 *        type: string
 *        enum:
 *          - created
 *          - deleted
 *          - updated
 */
export enum RegattaLogAction {
  created = 'created',
  deleted = 'deleted',
  updated = 'updated',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaRegistrationStatus:
 *        type: string
 *        enum:
 *          - ACTIVE
 *          - ENDED
 *          - OFF
 *          - SOON
 */
export enum RegattaRegistrationStatus {
  ended = 'ENDED',
  off = 'OFF',
  ongoing = 'ONGOING',
  upcoming = 'UPCOMING',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaRequirementType:
 *        type: string
 *        enum:
 *          - BOOLEAN
 *          - FILE
 *          - FILE_SOURCE
 *          - SELECT
 *          - SELECT_UNIQUE
 *          - VALUE
 *          - VALUE_UNIQUE
 */
export enum RegattaRequirementType {
  boolean = 'BOOLEAN',
  file = 'FILE',
  fileSource = 'FILE_SOURCE',
  select = 'SELECT',
  // selectUnique = 'SELECT_UNIQUE',
  value = 'VALUE',
  valueUnique = 'VALUE_UNIQUE',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaResultOverallType:
 *        type: string
 *        enum:
 *          - CT
 *          - ET
 *          - Points
 */
export enum RegattaResultOverallType {
  ct = 'CT',
  et = 'ET',
  points = 'Points',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaResultOverallFilter:
 *        type: string
 *        enum:
 *          - ADULT_CREW
 *          - ADULT_SKIPPER
 *          - FEMALE_CREW
 *          - FEMALE_SKIPPER
 *          - MALE_CREW
 *          - MALE_SKIPPER
 *          - U12
 *          - U13
 *          - U14
 *          - U15
 *          - U16
 *          - U18
 *          - U19
 *          - U21
 */
export enum RegattaResultOverallFilter {
  adultCrew = 'ADULT_CREW',
  adultSkipper = 'ADULT_SKIPPER',
  femaleCrew = 'FEMALE_CREW',
  femaleSkipper = 'FEMALE_SKIPPER',
  maleCrew = 'MALE_CREW',
  maleSkipper = 'MALE_SKIPPER',
  u12 = 'U12',
  u13 = 'U13',
  u14 = 'U14',
  u15 = 'U15',
  u16 = 'U16',
  u18 = 'U18',
  u19 = 'U19',
  u21 = 'U21',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaGroupRatingType:
 *        $ref = '#/components/enums/RatingType'
 */
export enum RegattaGroupRatingType {
  irc = 'IRC',
  lkrth = 'LKRTH',
  lys = 'LYS',
  monotype = 'MONOTYPE',
  orc = 'ORC',
  vjdh = 'VJDH',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaResultTableType:
 *        type: string
 *        enum:
 *          - BOARD
 *          - BOAT
 */
export enum RegattaResultTableType {
  board = 'BOARD',
  boat = 'BOAT',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaResultTableRaceType:
 *        type: string
 *        enum:
 *          - IRC
 *          - LKRTH
 *          - LYS
 *          - MONOTYPE
 *          - ORC_TN_TOD_HIGH_COSTAL_LONG_DISTANCE
 *          - ORC_TN_TOD_HIGH_WINDWARD_LEEWARD
 *          - ORC_TN_TOD_LOW_COSTAL_LONG_DISTANCE
 *          - ORC_TN_TOD_LOW_WINDWARD_LEEWARD
 *          - ORC_TN_TOD_MEDIUM_COSTAL_LONG_DISTANCE
 *          - ORC_TN_TOD_MEDIUM_WINDWARD_LEEWARD
 *          - ORC_TN_TOT_HIGH_COSTAL_LONG_DISTANCE
 *          - ORC_TN_TOT_HIGH_WINDWARD_LEEWARD
 *          - ORC_TN_TOT_LOW_COSTAL_LONG_DISTANCE
 *          - ORC_TN_TOT_LOW_WINDWARD_LEEWARD
 *          - ORC_TN_TOT_MEDIUM_COSTAL_LONG_DISTANCE
 *          - ORC_TN_TOT_MEDIUM_WINDWARD_LEEWARD
 *          - ORC_TOD_COSTAL_LONG_DISTANCE
 *          - ORC_TOD_WINDWARD_LEEWARD
 *          - ORC_TOT_COSTAL_LONG_DISTANCE
 *          - ORC_TOT_WINDWARD_LEEWARD
 *          - ROUNDINGS
 *          - VJDH
 */
export enum RegattaResultTableRaceType {
  irc = 'IRC',
  lkrth = 'LKRTH',
  lys = 'LYS',
  monotype = 'MONOTYPE',
  orcTnTodHighCostalLongDistance = 'ORC_TN_TOD_HIGH_COSTAL_LONG_DISTANCE',
  orcTnTodHighWindwardLeeward = 'ORC_TN_TOD_HIGH_WINDWARD_LEEWARD',
  orcTnTodLowCostalLongDistance = 'ORC_TN_TOD_LOW_COSTAL_LONG_DISTANCE',
  orcTnTodLowWindwardLeeward = 'ORC_TN_TOD_LOW_WINDWARD_LEEWARD',
  orcTnTodMediumCostalLongDistance = 'ORC_TN_TOD_MEDIUM_COSTAL_LONG_DISTANCE',
  orcTnTodMediumWindwardLeeward = 'ORC_TN_TOD_MEDIUM_WINDWARD_LEEWARD',
  orcTnTotHighCostalLongDistance = 'ORC_TN_TOT_HIGH_COSTAL_LONG_DISTANCE',
  orcTnTotHighWindwardLeeward = 'ORC_TN_TOT_HIGH_WINDWARD_LEEWARD',
  orcTnTotLowCostalLongDistance = 'ORC_TN_TOT_LOW_COSTAL_LONG_DISTANCE',
  orcTnTotLowWindwardLeeward = 'ORC_TN_TOT_LOW_WINDWARD_LEEWARD',
  orcTnTotMediumCostalLongDistance = 'ORC_TN_TOT_MEDIUM_COSTAL_LONG_DISTANCE',
  orcTnTotMediumWindwardLeeward = 'ORC_TN_TOT_MEDIUM_WINDWARD_LEEWARD',
  orcTodCostalLongDistance = 'ORC_TOD_COSTAL_LONG_DISTANCE',
  orcTodWindwardLeeward = 'ORC_TOD_WINDWARD_LEEWARD',
  orcTotCostalLongDistance = 'ORC_TOT_COSTAL_LONG_DISTANCE',
  orcTotWindwardLeeward = 'ORC_TOT_WINDWARD_LEEWARD',
  roundings = 'ROUNDINGS',
  vjdh = 'VJDH',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      ChampionshipAdminRequestStatus:
 *        $ref = '#/components/enums/AdminRequestStatus'
 */
export enum ChampionshipAdminRequestStatus {
  confirmed = 'CONFIRMED',
  fulfilled = 'FULFILLED',
  propose = 'PROPOSE',
  request = 'REQUEST',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaAdminRequestStatus:
 *        $ref = '#/components/enums/AdminRequestStatus'
 */
export enum RegattaAdminRequestStatus {
  confirmed = 'CONFIRMED',
  fulfilled = 'FULFILLED',
  propose = 'PROPOSE',
  request = 'REQUEST',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaNotificationType:
 *        type: string
 *        enum:
 *          - REGATTA_ENTRY_CREWMEMBER
 *          - REGATTA_MESSAGE
 *          - REGATTA_PROTEST
 *          - REGATTA_PROTEST_END
 *          - REGATTA_RESULTS_RACE_PUBLISHED
 *          - REGATTA_SETTINGS_CHANGED
 *          - REGATTA_TRACKING_ON
 */
export enum RegattaNotificationType {
  regattaEntryCrewmember = 'REGATTA_ENTRY_CREWMEMBER',
  regattaMessage = 'REGATTA_MESSAGE',
  regattaProtest = 'REGATTA_PROTEST',
  regattaProtestEnd = 'REGATTA_PROTEST_END',
  regattaResultTableRacePublished = 'REGATTA_RESULT_TABLE_RACE_PUBLISHED',
  regattaSettingsChanged = 'REGATTA_SETTINGS_CHANGED',
  regattaTrackingOn = 'REGATTA_TRACKING_ON',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaBoatRentStatus:
 *        type: string
 *        enum:
 *          - AVAILABLE
 *          - BOOKED
 *          - RESERVED
 */
export enum RegattaBoatRentStatus {
  available = 'AVAILABLE',
  booked = 'BOOKED',
  reserved = 'RESERVED',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaPaymentStatus:
 *        type: string
 *        enum:
 *          - FULFILLED
 *          - INTENT
 *          - PENDING
 */
export enum RegattaPaymentStatus {
  fulfilled = 'FULFILLED',
  intent = 'INTENT',
  pending = 'PENDING',
}

/**
 *  @swagger
 *  components:
 *    enums:
 *      RegattaProtestType:
 *        type: string
 *        enum:
 *          - PROTEST_BY_BOAT_AGAINST_BOAT
 *          - PROTEST_BY_RACE_COMMITTEE_AGAINST_BOAT
 *          - PROTEST_BY_PROTEST_COMMITTEE_AGAINST_BOAT
 *          - REQUEST_FOR_REDRESS_BY_BOAT_OR_RACE_COMMITTEE
 *          - CONSIDERATION_OF_REDRESS_BY_PROTEST_COMMITTEE
 *          - REQUEST_BY_BOAT_OR_RACE_COMMITTEE_TO_REOPEN_HEARING
 *          - CONSIDERATION_OF_REOPENING_BY_PROTEST_COMMITTEE
 */
export enum RegattaProtestType {
  type1BoatToBoat = 'PROTEST_BY_BOAT_AGAINST_BOAT',
  type2RcToBoat = 'PROTEST_BY_RACE_COMMITTEE_AGAINST_BOAT',
  type3PcToBoat = 'PROTEST_BY_PROTEST_COMMITTEE_AGAINST_BOAT',
  type4RcOrBoatRequestForRedress = 'REQUEST_FOR_REDRESS_BY_BOAT_OR_RACE_COMMITTEE',
  type5PcConsiderationOfRedress = 'CONSIDERATION_OF_REDRESS_BY_PROTEST_COMMITTEE',
  type6RcOrBoatRequestForReopen = 'REQUEST_BY_BOAT_OR_RACE_COMMITTEE_TO_REOPEN_HEARING',
  type7PcConsiderationOfReopen = 'CONSIDERATION_OF_REOPENING_BY_PROTEST_COMMITTEE',
}

export const ratingKeyValue = {
  [RatingType.irc]: 'GPH',
  [RatingType.lkrth]: 'GPH',
  [RatingType.lys]: 'GPH',
  [RatingType.monotype]: '',
  [RatingType.orc]: 'CDL',
  [RatingType.vjdh]: 'GPH',
};
